module.exports = __webpack_public_path__ + "img/pd-img25.1b882654.png";